import React from 'react'
import { Link } from 'react-router-dom'
import { logout } from '../../services/self'
import { RedocStandalone } from 'redoc';
import swaggerDoc from './NewformaAPI040323.json';

export default class Reference extends React.Component{

  logout() {
    logout()
    this.setState({ loggedOut: true })
  }
//ERP


render() {
  return(
<div>

<div>
<Link to='/documentation'>Back.....</Link>
</div>



<div className="contentz">
  <RedocStandalone
    spec={swaggerDoc}
  onLoaded={error => {
    if(!error){
      console.log(error);
    }
  }}
 />

</div>
</div>


)
}
}



/** WEBPACK FOOTER **
 ** ./src/pages/Reference/index.js
 **/